const ROLE_CUSTOMER = 1
const ROLE_ADMIN = 2
const THREATS_CATS = [56, 57, 59, 67]
const MATERIAL_COLORS_CHART_COLOR_LIST = [
    'red', 'purple', 'blue', 'green', 'indigo', 'orange', 'brown', 'lime', 'amber', 'cyan',
]

const LANG_NAMES = {
    ar: 'العربية',
    en: 'English',
    fr: 'Français',
    hi: 'मानक हिन्दी',
    ms: 'Bahasa Melayu',
    tr: 'Türkçe',
    id: 'Bahasa Indonesia',
}

const DARK_MODE_NAME = 'kidzonet-dark-mode'

export {
    DARK_MODE_NAME,
    LANG_NAMES,
    MATERIAL_COLORS_CHART_COLOR_LIST,
    ROLE_ADMIN,
    ROLE_CUSTOMER,
    THREATS_CATS,
}

export const avaliableCategoryList = [...Array.from({ length: 83 }).keys(), 84, 90, 91]
